// Module
var code = `<span delete-confirm="onDelete()"> <base-button btn-context="{{btnContext}}" btn-size="{{btnSize}}" btn-type="{{btnType}}"> <i class="fa fa-trash"></i> <span ng-class="{ 'sr-only': btnIconOnly }" translate>{{ btnLabel }}</span> </base-button> </span> `;
// Exports
module.exports = code;